import Vue from "vue";
import dayjs from 'dayjs'

export function priceFilter(num) {
    if(num) {
        // let englishNumber = this.convertToEnglishNumber(num);
        return num.toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
        return 0
    }
}


Vue.filter('price' , priceFilter)

Vue.filter('persianDate' , function(date) {
    return dayjs(date).locale('fa').format('HH:mm YYYY/MM/DD ')
})
Vue.filter('Date' , function(date) {
    return dayjs(date).format('YYYY/MM/DD ')
})

Vue.filter('date', function(date) {
    var now = new Date();
    let start = window.moment(date); // some random moment in time (in ms)
    let end = window.moment(now); // some random moment after start (in ms)
    let diff = end.diff(start);
    let time = moment.utc(diff).format("H:m:ss");
    let dayDiff = diff / (1000 * 60 * 60 * 24);
    let hour = time.split(":")[0];
    let min = time.split(":")[1];
    let second = time.split(":")[2];
    if ((hour == 0 && min == 0 && second <= 59 && dayDiff <= 1) || diff < 0) {
      return " چند ثانیه پیش";
    } else if (hour == 0 && min <= 59 && dayDiff <= 1) {
      return min + " دقیقه پیش";
    } else if (hour >= 1 && 24 >= hour && dayDiff <= 1) {
      return "حدود " + hour + " ساعت پیش";
    } else if (dayDiff > 1) {
      return dayjs(date).format("dddd jDD jMMMM jYYYY");
    }
})
